/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CommentsWidgetList_question = {|
  +id: string;
  +type: ?string;
  +answers: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
      |};
    |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "from",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "to",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "deviceIds",
      "type": "[ID]"
    },
    {
      "kind": "RootArgument",
      "name": "filterComments",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "demoData",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "questionFilters",
      "type": "[QuestionFilterInput]"
    },
    {
      "kind": "RootArgument",
      "name": "commentExtraColumns",
      "type": "[ID]"
    },
    {
      "kind": "RootArgument",
      "name": "count",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "cursor",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "answers"
        ]
      }
    ]
  },
  "name": "CommentsWidgetList_question",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "type",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "answers",
      "args": [
        {
          "kind": "Variable",
          "name": "demoData",
          "variableName": "demoData",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "deviceIds",
          "variableName": "deviceIds",
          "type": "[ID]"
        },
        {
          "kind": "Variable",
          "name": "filterComments",
          "variableName": "filterComments",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "from",
          "variableName": "from",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "lookupAnswersToQuestions",
          "variableName": "commentExtraColumns",
          "type": "[ID]"
        },
        {
          "kind": "Variable",
          "name": "questionFilters",
          "variableName": "questionFilters",
          "type": "[QuestionFilterInput]"
        },
        {
          "kind": "Variable",
          "name": "to",
          "variableName": "to",
          "type": "String"
        }
      ],
      "concreteType": "AnswerConnection",
      "name": "__CommentsWidgetList_answers_connection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "AnswerEdge",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Answer",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "CommentsWidgetListItem_answer",
                  "args": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "endCursor",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Question"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/CommentsWidgetList/__generated__/CommentsWidgetList_question.graphql.js